module.exports = __webpack_public_path__ + "media/images/svg/robles_concept-3486bef7cb8eea0e86e854db96fb7b80.svg";